export interface IcpCountry {
  id: number;
  country_name: string;
  iso_code: string;
  apollo_location_name: string;
  has_regions: boolean;
  regions: IcpRegion[];
}

export interface IcpRegion {
  id: number;
  region_name: string;
  region_type: string;
  apollo_location_name: string;
}

export interface IcpIndustry {
  id: number;
  industry_name: string;
}

export interface IcpTitle {
  id: number;
  title_name: string;
  seniority_level: string;
}

export interface IcpMasterData {
  countries: IcpCountry[];
  industries: IcpIndustry[];
  titles: IcpTitle[];
}

export interface IcpCountrySelection {
  country_id: number;
  region_ids: number[];
}

export interface IcpConfig {
  countries: IcpCountrySelection[];
  industry_ids: number[];
  title_ids: number[];
  company_sizes: string[];
}

export const ICP_LIMITS = {
  countries: { min: 1, max: 5 },
  industries: { min: 3, max: 5 },
  titles: { min: 10, max: 15 },
} as const;

export const COMPANY_SIZE_OPTIONS = [
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1000',
  '1000+',
] as const;
